import { ApplicationConfig, provideZoneChangeDetection, inject, provideAppInitializer } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';

import { routes } from './app.routes';
import { authInterceptor } from "./core/auth/auth.interceptor";
import { MetadataInterceptor } from './core/interceptors/metadata.interceptor';
import { MdbNotificationService } from 'mdb-angular-ui-kit/notification';
import { PermissionService } from './core/services/permission.service';
import { AuthService } from './core/auth/auth.service';

export function initializeApp() {
  const authService = inject(AuthService);
  return authService.checkAuthState();
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(
      withInterceptors([authInterceptor, MetadataInterceptor]),
      withFetch()
    ),
    provideAnimations(),
    MdbNotificationService,
    PermissionService,
    provideAppInitializer(initializeApp)
  ]
};
